import { useGLTF, useTexture } from '@react-three/drei'
import { useSnapshot } from 'valtio'
import { state } from '../../context/store'
import { modelParts, numberCoords } from '../../assets/models/193'
import {
  Ribs,
  MainSeat,
  RaceNumber,
  LogoMain,
  LogoRight,
  LogoLeft,
  TopPanelTexture,
} from './ModelSubComponents'
import { useRef } from 'react'
import { logoImagesLeft, logoImagesRight } from '../textures';
import * as THREE from 'three'

// This is the main ATV seat Model (AKA Raptor 700)
// Link to test
// /?type=atv&subtype=ribbed&test=yes

const Model193 = (props) => {
  const snap = useSnapshot(state.current)
  const { nodes, materials } = useGLTF(modelParts.main)

  // Model Variables
  const masterScale = 1.2
  const neededRibs = 6
  const ribPosition = [0.002, 0.025, 0.285]
  const ribScale = 1.063
  const topPanelTextureRepeat = 3
  const enjoyLogoPosition = [0, 0.003, 0.262]
  const enjoyLogoScale = 0.898
  const hexaLogoPosition = [0, 0.001, 0.261]
  const hexaLogoScale = 0.69
  // End Model Variables

  // Controls which extra parts are visible
  const visibleRibs = snap.choices.ribs.selected.mode !== 'no'
  const visibleTopLogo = snap.initialChoices.logoSize !== 'none'
  const visiblePattern = snap.choices.topPanel.selected.src !== null


  const LogoLeft = () => {
    const { nodes, materials } = useGLTF(modelParts.logoLeft)

    const logoRef = useRef()
    let logoTexture = useTexture(logoImagesLeft[snap.choices.sideLogos.selected.mode] ?? logoImagesLeft.none)
    // console.log(nodes)
    logoTexture.repeat.set(1, -1);
    logoTexture.wrapS = THREE.RepeatWrapping
    logoTexture.wrapT = THREE.RepeatWrapping
    logoTexture.flipY = true
    logoTexture.needsUpdate = true

    return (
      <group {...props} dispose={null}>
        <mesh
          castShadow={false}
          receiveShadow={false}
          transparent
          depthWrite={false}
          depthTest={false}
          geometry={nodes.LeftLogo.geometry}
          material={materials.LogosSide}
        >
          {
            snap.choices.sideLogos.selected !== "none" && (
              <meshStandardMaterial
                ref={logoRef}
                map={logoTexture}
                alphaTest={0.5}
                side={THREE.DoubleSide}
                onUpdate={(self) => (self.needsUpdate = true)}


              />
            )
          }

        </mesh>
      </group>


    )

  }
  const LogoRight = () => {
    const { nodes, materials } = useGLTF(modelParts.logoRight)

    const logoRef = useRef()
    // const imageRef = logoImagesRight[snap.sideLogoMode]
    // const imageLink = imageRef.slice(0, -5) + "-right" + imageRef.slice(-5)

    let logoTextureRight = useTexture(logoImagesRight[snap.choices.sideLogos.selected.mode] ?? logoImagesRight.none)
    logoTextureRight.repeat.set(1, -1);
    logoTextureRight.wrapS = THREE.RepeatWrapping
    logoTextureRight.wrapT = THREE.RepeatWrapping
    logoTextureRight.flipY = true
    logoTextureRight.needsUpdate = true

    return (
      <group {...props} dispose={null}>
        <mesh
          castShadow={false}
          receiveShadow={false}
          depthWrite={false}
          depthTest={false}
          geometry={nodes.RightLogo.geometry}
        >
          {
            snap.choices.sideLogos.selected !== "none" && (
              < meshStandardMaterial
                ref={logoRef}
                map={logoTextureRight}
                alphaTest={0.5}
                side={THREE.DoubleSide}
                onUpdate={(self) => (self.needsUpdate = true)}


              />
            )
          }

        </mesh>
      </group>


    )

  }


  return (
    <group {...props} dispose={null} scale={masterScale}>
      <MainSeat nodes={nodes} materials={materials}>
        {visiblePattern && (
          <TopPanelTexture
            repeat={topPanelTextureRepeat}
            normal={materials.TopPanel.normalMap}
          />
        )}
      </MainSeat>

      {visibleRibs && (
        <Ribs
          model={modelParts.ribs}
          neededRibs={neededRibs}
          position={ribPosition}
          scale={ribScale}
          tiles={0.8}
        />
      )}
      {visibleTopLogo && (
        <LogoMain
          model={modelParts.logoMain}
          model2={modelParts.logoHexa}
          position={enjoyLogoPosition}
          scale={enjoyLogoScale}
          position2={hexaLogoPosition}
          scale2={hexaLogoScale}
        />
      )}


      <RaceNumber
        model={modelParts.number}
        coords={numberCoords}
      />
      <LogoLeft />
      <LogoRight />
      {/* {visibleLogos && <LogoRight model={modelParts.logoRight} logo={snap.choices.sideLogos.selected} position={[0, 0.014, 0.286]} rotation={[0, 1, 0]} scale={0.792} />}
            {visibleLogos && <LogoLeft model={modelParts.logoLeft} logo={snap.choices.sideLogos.selected} position={[0, 0.014, 0.286]} rotation={[0, 0, 0]} scale={0.792} />} */}
    </group>
  )
}

export default Model193

useGLTF.preload(modelParts.main)
useGLTF.preload(modelParts.logoLeft)
useGLTF.preload(modelParts.logoRight)
useGLTF.preload(modelParts.logoMain)
